export default __webpack_public_path__ + "static/media/angbao-bonus.172b7a00.webp";